import React, { useState, useEffect } from 'react';
import {
  Box, makeStyles, Typography,
} from '@material-ui/core';
import Button from 'Components/UI/Button';
import PropTypes from 'prop-types';
import RichTextDisplay from 'Components/UI/RichTextDisplay';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import Paper from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Paper';

const useStyles = makeStyles(theme => ({
  noContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    width: '100%',
    '& > p': {
      maxWidth: '50%',
    },
  },
  meetingContent: {
    padding: theme.spacing(2),
    minHeight: theme.dimensions.sm,
    display: 'flex',
    justifyContent: 'flex-start',
    overflow: 'auto',
  },
  agendaNavigation: {
    padding: theme.spacing(2),
    border: 0,
    borderTop: '8px solid',
    borderImageSlice: 1,
    borderImageSource: `linear-gradient(to right, ${theme.palette.primary.main}, ${theme.palette.facet.accentBlue})`,
    display: 'flex',
    width: '100%',
  },
  pullRight: {
    marginLeft: 'auto',
  },
  agendaContainer: {
    overflow: 'hidden',
    height: '100%',
    width: '100%',
  },
}));

export default function Agenda({ meeting }) {
  const classes = useStyles();
  const [currentAgenda, setCurrentAgenda] = useState();
  const [currentAgendaIndex, setCurrentAgendaIndex] = useState();

  useEffect(() => {
    if (
      meeting
        ?.attr('agendas')
        ?.resources()
        .length() > 0
    ) {
      setCurrentAgenda(
        meeting
          .attr('agendas')
          .resources()
          .last(),
      ); // most recent
      setCurrentAgendaIndex(
        meeting
          .attr('agendas')
          .resources()
          .length() - 1,
      );
    } else {
      setCurrentAgenda(null);
      setCurrentAgendaIndex(null);
    }
  }, [meeting]);

  const nextAgendaExists = () => {
    if (
      currentAgendaIndex !== undefined
      && currentAgendaIndex
        < meeting
          .attr('agendas')
          .resources()
          .length()
          - 1
    ) {
      return true;
    }
    return false;
  };

  const prevAgendaExists = () => {
    if (currentAgendaIndex && currentAgendaIndex > 0) {
      return true;
    }
    return false;
  };

  const updateCurrentAgenda = (newIndex) => {
    if (
      meeting
        ?.attr('agendas')
        ?.resources()
        .length() > 0
    ) {
      setCurrentAgenda(
        meeting
          .attr('agendas')
          .resources()
          .index(newIndex),
      );
      setCurrentAgendaIndex(newIndex);
    }
  };

  return (
    <Paper className={classes.agendaContainer} variant="tight">
      <Box className={classes.agendaNavigation}>
        <Button
          color="secondary"
          disabled={!prevAgendaExists()}
          onClick={() => updateCurrentAgenda(currentAgendaIndex - 1)}
        >
          <ChevronLeftIcon /> Previous
        </Button>
        <Button
          color="secondary"
          className={classes.pullRight}
          disabled={!nextAgendaExists()}
          onClick={() => updateCurrentAgenda(currentAgendaIndex + 1)}
        >
          Next <ChevronRightIcon />
        </Button>
      </Box>
      <Box className={classes.meetingContent}>
        {currentAgenda ? (
          <RichTextDisplay content={currentAgenda.attr('content')} />
        ) : (
          <Box className={classes.noContent}>
            <Typography variant="h2" component="p" color="primary">
              Your planner is working on the agenda for your next meeting!
            </Typography>
          </Box>
        )}
      </Box>
    </Paper>
  );
}

Agenda.propTypes = {
  meeting: PropTypes.object.isRequired,
};
